module.exports = "../images/fishing-lodge-2-25.jpg?v=8d86ada";